const actionTypes = {
  setInfoFields: 'SET_INFO_FIELDS',
};

export default actionTypes;
